class Module06Media {
  constructor() {
    let cache = {};

    let initFunc = () => {
      initCache();
      registerEvents();
    };

    let initCache = () => {
      cache.sections = document.querySelectorAll('.module-06-media');
    };

    let registerEvents = () => {
      cache.sections.forEach(section => {
        const btn = section.querySelector('.video-play-pause');
        if (!btn) return;
        btn.addEventListener('click', () => togglePlayPause(section));
        section.querySelectorAll('video').forEach(video => {
          video.addEventListener('click', () => togglePlayPause(section));
        });
      });
    };

    let togglePlayPause = (section) => {
      const btn      = section.querySelector('.video-play-pause');
      if (!btn) return;

      const isMobile   = window.matchMedia('(max-width: 768px)').matches;
      const hasControl = isMobile ? btn.dataset.mobile === '1' : btn.dataset.desktop === '1';
      if (!hasControl) return;

      const video = isMobile
        ? (section.querySelector('video.mobile') || section.querySelector('video'))
        : (section.querySelector('video.desktop') || section.querySelector('video'));
      if (!video) return;

      if (video.paused) {
        video.play();
        btn.classList.add('playing');
      } else {
        video.pause();
        btn.classList.remove('playing');
      }
    };

    initFunc();
  };
}
export { Module06Media }
